<template>
  <div class="settings-icd-codes-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">ICD Codes</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addIcdCode"
        variant="primary"
        >New</b-button
      >
    </div>
    <div class="d-flex flex-row justify-content-end align-items-center mb-3">
      <b-form-group class="text-left mb-0">
        <b-form-input
          size="sm"
          placeholder="Search"
          v-model="search"
        ></b-form-input>
      </b-form-group>
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
      @storesort="listeners.storeSort"
    ></grid>
    <bottom-paginator
      :total="total"
      :page="paginator.page"
      :perPage="paginator.perPage"
      @change-page="changePage"
    />
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit ICD Code' : 'Add ICD Code'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitIcdCode"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <template v-if="formId" v-slot:modal-header>
        <div class="w-100 d-flex flex-row justify-content-between">
          <h5 class="modal-title">Edit ICD Code</h5>
          <div class="d-flex align-items-center">
            <button
              type="button"
              aria-label="Close"
              class="close text-white"
              @click="$refs['form-modal'].hide"
            >
              ×
            </button>
          </div>
        </div>
      </template>
      <b-form-group label="Code">
        <b-form-input v-model="form.code"></b-form-input>
      </b-form-group>
      <b-form-group label="Description">
        <b-form-input v-model="form.description"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import icdCodeServer from "../../server/icdCode";
import BottomPaginator from "../controls/BottomPaginator.vue";
import { mapActions } from "vuex";

export default {
  name: "DiagnosisCodeICDCodeCrud",
  components: {
    Grid,
    BottomPaginator
  },
  data() {
    const self = this;
    return {
      list: [],
      formId: null,
      form: {
        code: "",
        description: ""
      },
      search: "",
      total: 0,
      paginator: {
        page: 0,
        perPage: 10
      },
      orderBy: null,
      orderByDescending: false,
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.orderBy = field;
            self.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      }
    };
  },
  mounted() {
    this.getIcdCodes();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getIcdCodes() {
      this.total = await icdCodeServer.count({
        searchPhrase: this.search
      });
      this.list = await icdCodeServer.query({
        searchPhrase: this.search,
        page: this.paginator.page,
        pageSize: this.paginator.perPage,
        orderBy: this.orderBy,
        orderByDescending: this.orderByDescending
      });
    },
    async submitIcdCode() {
      const formData = {
        ...this.form,
        calories: parseInt(this.form.calories)
      };
      if (this.formId) {
        await icdCodeServer.update(this.formId, formData);
      } else {
        await icdCodeServer.create(formData);
      }
      this.getIcdCodes();
      this.showAlertSuccess();
    },
    addIcdCode() {
      this.formId = null;
      this.form = {
        code: "",
        description: ""
      };
      this.$refs["form-modal"].show();
    },
    changePage(page) {
      this.paginator.page = page;
      this.getIcdCodes();
    }
  },
  computed: {
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      let columns = [
        {
          text: "Code",
          field: "code",
          flex: 1,
          editor: false,
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Description",
          field: "description",
          flex: 1,
          editor: false,
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 110,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                const form = await icdCodeServer.get(this.formId);
                this.form = {
                  ...form
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await icdCodeServer.delete(record.id);
                    this.getIcdCodes();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    }
  },
  watch: {
    search: function() {
      this.paginator = {
        page: 0,
        perPage: 10
      };
      this.getIcdCodes();
    }
  }
};
</script>

<style>
.settings-icd-codes-container .b-grid-container .b-container {
  max-height: calc(100vh - 364px);
}
</style>
